module.exports = __webpack_public_path__ + "static/img/duofangguangbo2.58d6c10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/duofangguangbo2.png
// module id = 2EI3
// module chunks = 24